module.exports = __webpack_public_path__ + "img/2.3794af71.png";